import grey from '@weareroam/cake-ui-v1/colors/grey'

const theme = {
    palette: {
        primary: {
            light: grey[300],
            main: '#181424',
            dark: grey[700],
            faded: '#373737',
        },
        secondary: {
            lighter: '#f7f7f7',
            light: grey[100],
            main: grey[300],
            dark: grey[500],
        },
        black: '#181424',
        white: '#ffffff',
        red: '#ff6081',

        filter: {
            hover: '#443A5D',
        },
        textHover: {
            pink: '#fe628e'
        },
        icons: {
            white: '#fff',
            black: '#181424',
        },
        hr: {
            light: '#E9E9E9'
        },
    },
    effects: {
        boxShadow: '0px 10px 25px rgba(0,0,0,0.08)',
        boxShadowReverse: '0px -10px 25px rgba(0,0,0,0.08)',
        transition: {
            short: 'all .25s ease',
            medium: 'all .5s ease',
            long: 'all 1s ease',
        },
        textHover: {
            content: '"\xa0"',
            position: 'absolute',
            bottom: 0,
            left: 40,
            right: 'calc(100% - 39px)',
            height: 7,
            zIndex: -1,
            transition: 'all .3s ease',
        }
    },
    typography: {
        header: {
            medium: {
                fontFamily: 'Gilroy, Helvetica',
                fontSize: 36,
                fontWeight: 700,
            },
            large: {
                fontFamily: 'Gilroy, Helvetica',
                fontSize: 48,
                fontWeight: 700,
            }
        },
        footer: {
            fontFamily: 'Roboto',
            fontSize: '14px',
            textAlign: 'left',
            color: '#fff',
            opacity: 0.85,
        },
        paragraph: {
            small: {
                fontSize: 14,
                fontFamily: 'Lora',
            },
            medium: {
                fontSize: 16,
                fontFamily: 'Lora',
            }
        },
        label: {
            small: {
                textAlign: 'center',
                fontSize: 14,
                fontFamily: 'Gilroy, Helvetica',
                fontWeight: 700,
            },
            medium: {
                fontWeight: 700,
                fontSize:  20,
                fontFamily: 'Gilroy, Helvetica',
            },
            phase: {
                fontFamily: 'Gilroy, Helvetica',
                textTransform: 'uppercase',
                fontSize: 12,
                letterSpacing: 1,
                color: '#AAAAAA',
            },
            equipment: {
                fontSize: 12,
                fontFamily: 'Gilroy, Helvetica',
                wordWrap: 'break-word',
                textAlign: 'center',
            },
            card: {
                fontWeight: 700,
                fontSize:  13,
                fontFamily: 'Gilroy, Helvetica',
            }
        },
        quote: {
            color: '#fff',
            textAlign: 'center',
            fontSize: 36,
            fontFamily: 'Lora-Italic'
        },
        table: {
            fontFamily: 'Roboto',
            fontSize: 16,
            fontWeight: 300,
            color: '#DDDDDD',
        },
        stamp: {
            fontFamily: 'Gilroy, Helvetica',
            fontWeight: 700,
            fontSize: 12,
        },
        dark: {
            label: {
                fontFamily: 'Gilroy, Helvetica',
                fontWeight: 700,
                fontSize: 12,
                color: '#fff',
                opacity: 0.3,
                textTransform: 'uppercase',
            },
            header: {
                color: '#4E4A5A',
                fontSize: 36,
                fontWeight: 700,
            }
        },
        error: {
            color: '#f44336',
            fontSize: 16,
            fontFamily: 'Roboto'
        },
        link: {
            fontFamily: 'Gilroy, Helvetica',
            fontWeight: 600,
            fontSize: 18,
        }
    },
    screens: {
        mobile: '@media only screen and (max-width: 484px)',
        small: '@media only screen and (max-width: 656px)',
        tablet: '@media only screen and (max-width: 768px)',
        largeTablet: '@media only screen and (max-width: 956px)',
        medium: '@media only screen and (max-width: 1024px)',
        large: '@media only screen and (max-width: 1280px)',
    },
    spacing: {
        small: 50,
        smallMedium: 75,
        medium: 100,
        mediumLarge: 125,
        large: 150
    },
    position: {
        hidden: {
            maxHeight: 0,
            overflow: 'hidden',
        }
    }
}

export default theme



// WEBPACK FOOTER //
// ./src/utils/theme.js